<script type="text/javascript">
	import { Label } from "@smui/button";
	import Button from "@smui/button/Button.svelte";
	import moment from "moment";
	import Datepicker from "svelte-calendar";
	import { get,writable } from "svelte/store";
	import AppStore from "../../AppStore";
	import LoadState from "../../Enums/LoadState";
	import GenericLineChart from "../../Graphs/GenericLineChart.svelte";
	import GenericPieChart from "../../Graphs/GenericPieChart.svelte";
	import GeoHelper from "../../Helpers/GeoHelper";
	import { getTwoYearsAgoFudge } from "../../Helpers/Misc/timeHelper";
	import MapStore from "../../Map/Store";
	import "../../UI/LayerList/LayerList.scss";
	import ModalWindow from "../../UI/ModalWindow.svelte";
	import Spinner from "../Spinner/Spinner.svelte";
		
	let visible = AppStore.miss.visible;
	let loadState = AppStore.miss.meta.loadState;
	let loaded = false;
	
	let filterCrimeType = writable("");
	let allCrimeTypes = [];

	let filterDateType = writable("");
	let datePickerStrFormat = "#{F} #{j}, #{Y}";
	let fromFormattedSelected, toFormattedSelected;
	const today = new Date();
	let twoYearsAgo = getTwoYearsAgoFudge();
	let earliestVHTime = twoYearsAgo;
	let fromDateTimeStore = writable(new Date());
	let toDateTimeStore = writable(new Date());

	let resultsLength = 0;

	let crimePie = null;
	let crimeLineChart = null;
	let crimeTypePieData = writable({});
	let crimeTypeLineData = writable({});
	
	$: {
		loaded = $loadState === LoadState.LOADED;

		if (loaded) {
			initFilters();
			updateFilters();
		}
	}
	let addFeatureToChartLineData = (momentDate, crimeType) => {

		let dateKey = momentDate.format("YYYY-MM-DD");
		// console.log("dateKey", dateKey);
		if (typeof $crimeTypeLineData[dateKey] === "undefined") {
			let thisFeature = {
				"Date": dateKey,
				"data": {
					"Graph_type": {
						[crimeType]: 0,
						"Total": 0
					}
				}
			};
			$crimeTypeLineData[dateKey] = thisFeature;
		}
		$crimeTypeLineData[dateKey].data.Graph_type[crimeType] = parseInt($crimeTypeLineData[dateKey].data.Graph_type[crimeType] || 0) + 1;
		$crimeTypeLineData[dateKey].data.Graph_type.Total += 1;
		
	};
	let initFilters = () => {
		let featureCollection = get(AppStore.miss.getDisplayLayer("agol_miss").featureCollection);
		let allFeatures = featureCollection.features;

		// Set up crime filter types. 
		if (allCrimeTypes.length == 0) { 
			for(let i = 0; i < allFeatures.length; i++) {
				let crimeType = allFeatures[i].properties.Aggressor.trim();
				if (crimeType.length > 0) { 
					// Add to overall crime types.
					if (allCrimeTypes.indexOf(crimeType) === -1) { 
						allCrimeTypes.push(crimeType);
					}
				}
			}
			allCrimeTypes.sort();
		}
	};
	let updateFilters = () => {
		$crimeTypePieData = {};
		$crimeTypeLineData = {};

		// Filter map data by filters. 
		let featureCollection = get(AppStore.miss.getDisplayLayer("agol_miss").featureCollection);
		let allFeatures = featureCollection.features;
		let newFeatures = [];
		if ($filterCrimeType === "") {
			newFeatures = [...allFeatures];
		} 
		else {
			for(let i = 0; i < allFeatures.length; i++) {
				const crimeType = allFeatures[i].properties.Aggressor.trim();
				if (crimeType === $filterCrimeType) {
					newFeatures.push(allFeatures[i]);
				}
			}
		}

		// TODO: enumise date filter type? 
		if ($filterDateType !== "") { 
			let startDate = moment();
			let endDate = moment();
			if ($filterDateType === "week") { 
				startDate = moment().subtract(1, "week");
			}
			else if ($filterDateType === "month") { 
				startDate = moment().subtract(1, "month");
			}
			else if ($filterDateType === "range") {
				startDate = moment($fromDateTimeStore);
				endDate = moment($toDateTimeStore);
				// console.log("start", startDate.toLocaleString(), endDate.toLocaleString());
			}
			for(let i = 0; i < newFeatures.length; i++) {
				const occurenceDate = moment(new Date(newFeatures[i].properties.DateofOccurenceTime));
				// console.log("filtering", occurenceDate, startDate, endDate);
				if (occurenceDate < startDate || occurenceDate > endDate) {
					newFeatures.splice(i, 1);
					i--;
				}
				else {
					// Add to pie graph
					
					let crimeType = newFeatures[i].properties.Aggressor.trim();
					if (crimeType.length > 0) { 
						if (typeof $crimeTypePieData[crimeType] === "undefined") {
							$crimeTypePieData[crimeType] = 0;
						}
						$crimeTypePieData[crimeType]++;

						addFeatureToChartLineData(occurenceDate, crimeType)
					}
					
				}
			}
			$crimeTypePieData = $crimeTypePieData;
		}
		else {
			// Add to pie graph
			for(let i = 0; i < allFeatures.length; i++) {
				let crimeType = allFeatures[i].properties.Aggressor.trim();
				if (crimeType.length > 0) { 
					if (typeof $crimeTypePieData[crimeType] === "undefined") {
						$crimeTypePieData[crimeType] = 0;
					}
					$crimeTypePieData[crimeType]++;

					const occurenceDate = moment(new Date(allFeatures[i].properties.DateofOccurenceTime));
					addFeatureToChartLineData(occurenceDate, crimeType)
				}
			}
			$crimeTypePieData = $crimeTypePieData;
		}
		resultsLength = newFeatures.length;

		const map = MapStore.helpers.getMap();
		map.getSource("agol_miss_0").setData(GeoHelper.emptyGeoJson(newFeatures));
	};
	let hstyle = "font-weight:bold;margin-top:5px;margin-bottom:5px;";

	$: {
		$crimeTypePieData;
		if (crimePie) {
			crimePie.updateData();
		}
		if (crimeLineChart) {
			console.log("crimeTypeLineData", $crimeTypeLineData);
			crimeLineChart.updateData();
		}
	}

</script>


<ModalWindow
	title={`Maritime Incidents`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={true}
	position="top-right"
	height="70%"
	bind:open={$visible} >

	{#if !loaded}
		<Spinner/>
	{:else}

		<p style={hstyle}>Filters</p>
		
		<p><b>Crime Type</b></p>
		<select class='default' bind:value={$filterCrimeType} on:change={updateFilters}>
			<option value="">Show All</option>
			{#each allCrimeTypes as crimeType}
				<option value={crimeType}>{crimeType}</option>
			{/each}
		</select>

		<p><b>Date</b></p>
		<select class='default' bind:value={$filterDateType} on:change={updateFilters}>
			<option value="">Show All</option>
			<option value="week">Last 7 days</option>
			<option value="month">Last 30 days</option>
			<option value="range">Within Date Range</option>
		</select>
		{#if $filterDateType === "range"}
			<Datepicker
				start={earliestVHTime}
				end={$toDateTimeStore}
				format={datePickerStrFormat}
				bind:selected={$fromDateTimeStore}
				bind:formattedSelected={fromFormattedSelected}
				on:dateSelected={updateFilters}
				>
				<Button color="secondary" variant="unelevated" style="width:100%;margin-top:10px;" ><Label>From: {fromFormattedSelected}</Label></Button>
			</Datepicker>

			<Datepicker
				start={$fromDateTimeStore}
				end={today}
				format={datePickerStrFormat}
				bind:selected={$toDateTimeStore}
				bind:formattedSelected={toFormattedSelected}
				on:dateSelected={updateFilters}>
				<Button color="secondary" variant="unelevated" style="width:100%;margin-top:5px;" ><Label>To: {toFormattedSelected}</Label></Button>
			</Datepicker>
		{/if}
		<p><b>{resultsLength} result{(resultsLength !== 1)?"s":""}</b></p>

		{#if $filterCrimeType === ""}
			<GenericPieChart bind:this={crimePie} title="Crime Types" bind:data={$crimeTypePieData} /><br/>

			<GenericLineChart bind:this={crimeLineChart} title="Crimes Timeseries" data={Object.values($crimeTypeLineData)} keys={["Total", ...allCrimeTypes]}/><br/>
		{/if}

	{/if}

</ModalWindow>
